/** Converts markdown links to html links for builder editor and distribution contexts. */
export const markdownToHtmlURL = (markdown: string, isBuilder: boolean) => {
  return markdown.replace(
    /[[]{1}([^\]]+)[\]]{1}[(]{1}([^)"]+)("(.+)")?[)]{1}/g,
    isBuilder
      ? '<a href="$2" style="pointer-events: none;" contenteditable="false">$1</a>'
      : '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
  )
}
